import { client } from './client'

export const signIn = async (username, password) =>
  await client.post('/api/v1/sessions', { username, password }).then(
    (v) => [null, v.data],
    (err) => [err, null],
  )
